import '@rmwc/radio/styles';
import {
  Radio as RMWCRadio,
  type RadioProps,
  type RadioHTMLProps,
} from '@rmwc/radio';

const Radio = (
  props: Partial<RadioProps & RadioHTMLProps>,
): React.JSX.Element => {
  return <RMWCRadio {...props} />;
};

export {Radio};
